module.exports = ".action-dialog {\n    border-radius: 6px;\n}\nlabel\n{\n    display: block;\n    margin: 10px 0;\n    text-align: center;\n}\nlabel span\n{\n    display: inline-block;\n    text-align: right;\n    width: 100px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/update-price-dialog/update-price-dialog.component.css
// module id = ./src/app/shared/components/update-price-dialog/update-price-dialog.component.css
// module chunks = main